module.exports = __webpack_public_path__ + "img/ico-arrow-r.ae71b765.svg";